import React from "react";
import { Grid } from "@material-ui/core";
import StepperTurnos from "./StepperTurnos";


export const IngresoTurnos = () => {

  return (
    <Grid container direction="row" alignItems="center">  
      <StepperTurnos desdeHce={false}/>
    </Grid>
  );

};
  